import React, { useState, useEffect } from 'react';
import '../../css/homepage.css';
import PageIllustration from '../../img/homepage_illustration.svg';
import { useToast } from '@chakra-ui/react';

import VenoBox from 'venobox';
import { Link } from "react-router-dom";
import { getRequest } from '../../utilities/server-utils';
import { getArticleSummary } from "../../utilities/utils";
import GalleryPostCard from "../../ui-components/gallery-post-card";
import ArticleHighlightCard from '../../ui-components/article_highlight_card';


import PythonUIcon from '../../img/icons/python_icon.svg';
import HTMLIcon from '../../img/icons/html_icon.svg';
import JSIcon from '../../img/icons/javacscript_icon.svg';
import CSSIcon from '../../img/icons/css_icon.svg';
import PHPIcon from '../../img/icons/php_icon.svg';
import GodotIcon from '../../img/icons/godot_icon.svg';
import BlenderIcon from '../../img/icons/blender_icon.svg';
import SQLIcon from '../../img/icons/SQL_icon.svg';

import ArticleHighlightCardSkeleton from "../../ui-components/article-highlight-card-skeleton";
import GalleryPostCardSkeleton from '../../ui-components/gallery-post-card-skeleton';

import ReactJSIcon from '../../img/icons/reactjs.svg';
import ReactNativeIcon from '../../img/icons/react-native.svg';
import DJangoRFIcon from '../../img/icons/django-rf.svg';
import DjangoIcon from '../../img/icons/django.svg';
import LaravelIcon from '../../img/icons/laravel.svg';
import TailwindIcon from '../../img/icons/tailwind.svg';
import Bootstrap from '../../img/icons/bootstrap.svg';
import ScikitLearnIcon from '../../img/icons/scikitlearn.svg';
import NumpyIcon from '../../img/icons/numpy.svg';
import MatplotlibIcon from '../../img/icons/matplotlib.svg';
import AxiosIcon from '../../img/icons/axios.svg';
import PandasIcon from '../../img/icons/pandas.svg';
import GithubIcon from '../../img/icons/github.svg';
import LinkedInIcon from '../../img/icons/linkedin.svg';
import MySQLIcon from '../../img/icons/mysql_icon.svg';



// Custom Templates
import SkillCardTemplate from '../../ui-components/skill-card-template';
import TitleHeader from '../../ui-components/title-header';
import ProjectCard from '../../ui-components/projects-card';





const Home = () => {
    const [highlight_articles, setHightlightArticles] = useState(null);
    const [highlight_image, setHighlightImage] = useState(null);
    const [projects, setProjects] = useState(null);

    const toast = useToast();

    const skills = {
        python: {
            title: 'Python',
            description: 'Skilled in Python for web development, data science, and AI, with experience in Django, Django Rest Framework, Pandas, and Scikit-learn.'
        },
        html: {
            title: 'HTML',
            description: 'Skilled in HTML, the standard markup language for web documents, with knowledge of CSS and JavaScript.'
        },
        javascript: {
            title: 'JavaScript',
            description: 'Skilled in JavaScript for creating interactive web pages and applications, widely supported by modern web browsers.'
        },
        css: {
            title: 'CSS',
            description: 'Skilled in CSS for controlling the look and formatting of HTML documents.'
        },
        php: {
            title: 'PHP',
            description: 'Skilled in PHP for server-side scripting and web development, compatible with various databases.'
        },
        godot: {
            title: 'Godot Game Engine',
            description: 'Skilled in Godot, an open-source game engine for creating games and interactive applications.'
        },
        blender: {
            title: 'Blender',
            description: 'Skilled in Blender, a 3D computer graphics software for creating animated films, visual effects, and more.'
        },
        sql: {
            title: "SQL",
            description: 'Knowledgable in SQL for managing and manipulating relational databases, with experience in writing queries and ensuring data integrity.'
        }
    }


    useEffect(()=>{
        new VenoBox({
            selector: '.my-image-links',
            numeration: true,
            infinigall: true,
            share: true,
            spinner: 'rotating-plane'
        });

        
        const getHighlightArticle = async()=>{
            let url_path = "/public/article/?is_highlight=true&is_posted=true";
            await getRequest(url_path)
            .then(response => {
                if(response.status === 200){
                    setHightlightArticles(response.data);
                }
            })
            .catch(error => {
                toast({
                    title: 'API Warning',
                    description: "Interuption Error: A reload usually fix this error: " + error,
                    status: 'warning',
                    duration: 9000,
                    isClosable: true,
                });
            })
        }


        const loadGallery = async()=>{
            let url_path = "/public/gallery/?is_highlight=true";
            await getRequest(url_path)
            .then(responseData => {
                setHighlightImage(responseData.data);
            })
            .catch(error => {
                toast({
                    title: 'API Warning',
                    description: "Interuption Error: A reload usually fix this error: " + error,
                    status: 'warning',
                    duration: 9000,
                    isClosable: true,
                });
            });
        }


        const loadProjects = async()=>{
            let url_path = "/projects/public/";
            await getRequest(url_path)
            .then(responseData => {
                setProjects(responseData.data);
            })
            .catch(error => {
                toast({
                    title: 'API Warning',
                    description: "Interuption Error: A reload usually fix this error: " + error,
                    status: 'warning',
                    duration: 9000,
                    isClosable: true,
                });
            });
        }

        loadGallery();
        getHighlightArticle();
        loadProjects();
        
        window.scrollTo(0, 0);
    }, [toast]);

    return ( 
        <div className="home">
            <div className="container">
                <div className="row h-[90vh]">
                    <div className="col-md-6 px-5 d-flex align-items-center justify-content-center">
                        <div className="">
                            <span className='text-3xl' >my name is</span> <br/>
                            <span className='font-bold md:text-6xl text-5xl md-pt-5 color-primary'>Mark John</span><br/>
                            <p id="intro_sub_3" className='font-primary mb-3 pt-3 leading-relaxed'>
                                An Astronomer, Artist, Application Developer, Web Developer, and a Game Developer. Most importantly, I play guitar.
                            </p>

                            <div className='d-flex flex-row align-items-center justify-content-between'>
                                <Link to="/pages/contact" className="primary-button mr-3" aria-current="page">Contact Me</Link>
                                <div className='d-flex mb-4 mt-4'>
                                    <img src={ GithubIcon } alt="github" className="w-8 h-8 mr-2 cursor-pointer" onClick={()=>(window.location.href = 'https://github.com/callmemark')}/>
                                    <img src={ LinkedInIcon } alt="linkedin" className="w-8 h-8 cursor-pointer" onClick={()=>(window.location.href='https://www.linkedin.com/in/mark-john-velmonte-mark')}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 d-block d-md-block d-flex d-md-flex align-items-center justify-content-center">
                        <img src={PageIllustration} alt="illustration" className=" w-[30rem]"/>
                    </div>
                </div>
                
                
                <div className='row mt-5 pt-5'>
                    <div className='col-12'>
                        <div id="tech_skill_header_cont">
                            <TitleHeader title={"Technical Skills"} subtitle={"Skills Ive gain over the years"} />
                        </div>

                        <div className='row mt-2'>
                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate 
                                    skill_name={skills.python.title} 
                                    skill_description={skills.python.description} 
                                    skill_image={PythonUIcon} 
                                    badge_item={
                                    [
                                        [DjangoIcon, "Django Web Framework"], 
                                        [DJangoRFIcon, "Django Rest Framework"], 
                                        [ScikitLearnIcon, "Scikit Learn Library"], 
                                        [NumpyIcon, "Numpy Library"], 
                                        [MatplotlibIcon, "Matplotlib Library"], 
                                        [PandasIcon, "Pandas Library"]
                                    ]
                                }/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate 
                                    skill_name={skills.javascript.title} 
                                    skill_description={skills.javascript.description} 
                                    skill_image={JSIcon} 
                                    badge_item={
                                        [
                                            [ReactJSIcon, "ReactJS Library"], 
                                            [ReactNativeIcon, "React Native Framework"], 
                                            [AxiosIcon, "Axios Library"]
                                        ]
                                    }/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.html.title} skill_description={skills.html.description} skill_image={HTMLIcon}/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.css.title} skill_description={skills.css.description} skill_image={CSSIcon} badge_item={
                                    [
                                        [TailwindIcon, "Tailwind Library"], 
                                        [Bootstrap, "Bootstrap Library"]
                                    ]
                                }/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.php.title} skill_description={skills.php.description} skill_image={PHPIcon} badge_item={
                                    [
                                        [LaravelIcon, "Laravel Framework"]
                                    ]
                                }/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.godot.title} skill_description={skills.godot.description} skill_image={GodotIcon}/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.blender.title} skill_description={skills.blender.description} skill_image={BlenderIcon}/>
                            </div>

                            <div className='col-md-6 p-3'>
                                <SkillCardTemplate skill_name={skills.sql.title} skill_description={skills.sql.description} skill_image={SQLIcon} badge_item={
                                    [
                                        [MySQLIcon, "MySQL Database"]
                                    ]
                                }/>
                            </div>

                        </div>
                    </div>
                </div>


                <div className='row my-40 px-3 xs:p-0 mt-5' id="section-5">
                    <div className='col-12'>
                        <TitleHeader title={"Projects"} subtitle={"Created Projects"} />
                        <div className='row mt-5 px-4'>
                            {
                                projects !== null ?
                                projects.map((project)=>(
                                    <ProjectCard project_image={project.project_icon} project_title={project.project_name} project_description={project.project_description} project_link={project.project_url} />
                                ))
                                

                                :
                                <div div className='row'>
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                </div>
                            }   
                        </div>
                    </div>
                </div>

                <div className='row my-40 px-3 xs:p-0' id="section-3">
                    <div className='col-12'>
                        <TitleHeader title={"Highlight Article"} subtitle={"Must read articles"} />
                        
                        <div className='row mt-5'>
                            { 
                                highlight_articles 
                                ? 
                                    Object.keys(highlight_articles).map(article_key => {
                                        let summary = getArticleSummary(highlight_articles[article_key].article_data.blocks)
                                        return <div className="col-sm-4 mt-4">
                                            <ArticleHighlightCard title={summary.heading} body={summary.parapgraph} image={summary.cover_image} article_id={highlight_articles[article_key].id}/>
                                        </div>
                                    })
                                :
                                    (highlight_articles && Object.keys(highlight_articles).length === 0)
                                ?
                                    <p className="font-bold text-2xl text-center color-black ">No articles yet</p>
                                :
                                    <>
                                        <div className="col-sm-4 mt-4">
                                            <ArticleHighlightCardSkeleton />
                                        </div>
                                        <div className="col-sm-4 mt-4">
                                            <ArticleHighlightCardSkeleton />
                                        </div>
                                        <div className="col-sm-4 mt-4">
                                            <ArticleHighlightCardSkeleton />
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                

                <div className='row m-20 bg-gray-100 rounded-lg' id="section-4">
                    <div className='col-md-12 pt-5 pb-5'>
                        <TitleHeader title={"Gallery"} subtitle={"Current Best renders"} />

                        <div className='row mt-5'>
                            {
                                highlight_image 
                                ?
                                Object.keys(highlight_image).map((key) => (
                                    <div className="col-sm-3 mt-2">
                                        <div className="pl-1 pr-1 pt-1">
                                            <GalleryPostCard gallery_post_data = {highlight_image[key]} is_authenticated={false} delete_callback={null}/>  
                                        </div>
                                    </div>
                                ))
                                :
                                <>
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                    <GalleryPostCardSkeleton />
                                </> 
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Home;
